/**
 *
 * key
 *
 */

 const key = 'bXlUZWFtU2NoZWR1bGU='

 export default key
 